import { render, staticRenderFns } from "./MdTitle.vue?vue&type=template&id=6e2ac119&scoped=true&"
import script from "./MdTitle.vue?vue&type=script&lang=js&"
export * from "./MdTitle.vue?vue&type=script&lang=js&"
import style0 from "./MdTitle.vue?vue&type=style&index=0&id=6e2ac119&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ac119",
  null
  
)

export default component.exports